import React from "react"
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Navbar from "./Navbar"
import Menu from "./Menu"
import Footer from "./Footer"
import { FloatButton } from 'antd'
import { loadJekka } from '@/utils/jekka';
import { loadGtm } from '@/utils/gtm';
import { loadMatomo } from "@/utils/matomo";
import { loadForter } from "@/utils/forter";
import { abTestCalculate } from "@/utils/ABtest";
import GoogleAnalytics from "./GoogleAnalytics";

interface LayoutProps {
  children: React.ReactNode;
  wideScreen?: boolean;  // 是否使用宽屏
  notStickyNavbar?: boolean; // 是否取消Navbar吸顶效果
}

export default function DefaultLayout(props: LayoutProps) {
  const router = useRouter();

  useEffect(() => {
    // 加载AB测试逻辑
    abTestCalculate("2025-07-16_ABTest_Swiper")
  }, [])

  useEffect(() => {
    // 创建字体链接
    const loadFonts = () => {
      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = 'https://fonts.googleapis.com/css?family=Rubik:300,400,500,700,900&display=swap';
      
      // 添加预连接优化
      const preconnectLink = document.createElement('link');
      preconnectLink.rel = 'preconnect';
      preconnectLink.href = 'https://fonts.gstatic.com';
      preconnectLink.crossOrigin = 'anonymous';
      
      document.head.appendChild(preconnectLink);
      document.head.appendChild(fontLink);
    };

    // 动态创建广告脚本
    const loadAdScript = () => {
      const adsbygoogleScript = document.createElement('script');
      adsbygoogleScript.async = true;
      adsbygoogleScript.src = "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      document.body.appendChild(adsbygoogleScript);
    };

    // 动态创建Criteo脚本
    const loadCriteoScript = () => {
      const criteoScript = document.createElement('script');
      criteoScript.async = true;
      criteoScript.src = "https://static.criteo.net/js/ld/ld.js";
      document.body.appendChild(criteoScript);
    };

    function handleWindowLoad() {
      loadFonts();
      loadAdScript();
      loadCriteoScript();
      loadJekka();
      loadMatomo();
      loadGtm();
      loadForter();
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  return (
    <div>
      <GoogleAnalytics />
      <Navbar
        wideScreen={props.wideScreen}
        useChristmasTheme={router.pathname.includes('/my-account') ? false : false}
        sticky={props.notStickyNavbar ? false : true}
      />

      <Menu 
        wideScreen={props.wideScreen}
        useChristmasTheme={router.pathname.includes('/my-account') ? false : false} 
      />

      <main style={{ background: '#F5F5F5' }}>{props.children}</main>

      <Footer />
      <FloatButton.BackTop />
    </div>
  )
}